










































































import Vue from 'vue';
import Map from './components/Map.vue';
import {mapState} from "vuex";

export default Vue.extend({
  name: 'App',
  computed: {
    ...mapState(['data',]),
  },
  components: {
    Map,
  },

  data: () => ({
    dialog: false
  }),
});
